<template>
  <el-dialog width="700px" append-to-body title="编辑地址" :visible.sync="visible" :before-close="handleClose">
    <el-form class="xm-form" autoComplete="on" :model="address" v-loading="loading" :rules="addressRules"
      element-loading-text="给我一点时间" label-position="right" ref="address" label-width="150px">
      <el-form-item label="收货人" prop="recipient_name">
        <el-input type="text" style="width:250px" v-model="address.recipient_name" placeholder="请输入姓名"> </el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="recipient_phone">
        <el-input type="text" style="width:250px" v-model="address.recipient_phone" placeholder="请输入联系电话">
        </el-input>
      </el-form-item>
      <el-form-item label="选择地址" prop="areaArr">
        <el-cascader style="width:350px;" v-model="address.areaArr" placeholder="请选择地址" clearable :props="cascaderProp"
          :options="areaList">
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="detail">
        <el-input style="width:450px" type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" v-model="address.detail"
          placeholder="请输入详细地址">
        </el-input>
      </el-form-item>

      <el-form-item label="是否默认" prop="is_default">
        <el-switch v-model="address.is_default" :active-value="1" :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleEditAddress" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveAddress } from '@/api/address'
import { getAreaTree } from '@/api/common'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'EditAddress',
  components: {

  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    oldAddress: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getAreaTree();
        const _address = Object.assign({}, this.oldAddress);
        _address.areaArr = [_address.province_id, _address.city_id, _address.district_id];
        this.address = Object.assign(_address);
      }
    }
  },
  data() {
    return {
      loading: false,
      address: {
        id: 0,
        recipient_name: '',
        recipient_phone: '',
        areaArr: [],
        detail: '',
        is_default: 0,
      },
      addressRules: {
        recipient_name: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        recipient_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        areaArr: [
          { required: true, message: '请选择地址', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
      },
      areaList: [],
      cascaderProp: {
        value: 'id',
        label: 'name',
        children: '_child',
        disabled: 'disabled'
      },
    }
  },
  methods: {
    // 获取所有地区
    getAreaTree() {
      getAreaTree({}).then(response => {
        this.areaList = response.data
      }).catch(() => {

      })
    },
    // 编辑地址
    handleEditAddress() {
      // 验证form表单
      this.$refs.address.validate(valid => {
        if (valid) {
          this.loading = true
          const _address = JSON.parse(JSON.stringify(this.address))
          _address.province_id = _address.areaArr ? _address.areaArr[0] : 0;
          _address.city_id = _address.areaArr ? _address.areaArr[1] : 0;
          _address.district_id = _address.areaArr ? _address.areaArr[2] : 0;
          saveAddress(_address).then(response => {
            this.loading = false
            // 关闭窗口
            this.handleClose()
            // 触发父组件的callback事件
            this.$emit('getList')
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.address) {
        this.$refs.address.resetFields()
      }
      // 更新visible参数
      this.$emit('update:visible', false)
    }
  }
}
</script>
